export default "__VITE_ASSET__CPEiJXVp__";